module.exports = __webpack_public_path__ + "img/applicable-scene-3.bb7f849.png";